import React from 'react'

export default React.memo(function PageNotFound() {
  return <div>Not found page</div>
})
